import { productIcons } from './ProductIcons';
import * as Styled from './Products.styled';
import { ISectionData } from './ProductsNav';

import * as React from 'react';

const ProductsNavSection = ({ productKey, items }: ISectionData) => {
  const Icon = productIcons[productKey];

  return (
    <Styled.StyledList>
      {items.map((item, index) => {
        const isSectionTitle = index === 0;

        return (
          <li key={item.title}>
            <Styled.StyledLink
              href={item.link}
              aria-label={item.title}
              $isActive={item.isActive}
            >
              {isSectionTitle && (
                <Styled.SectionTitle>
                  <Icon />

                  <div
                    style={{
                      fontWeight: item.title === 'Settings' ? 'normal' : 600,
                    }}
                  >
                    {item.title}
                  </div>
                </Styled.SectionTitle>
              )}

              <Styled.Section>
                {!isSectionTitle && item.title}
                {item.isPreview && <Styled.PreviewTag color='cyan'>Preview</Styled.PreviewTag>}
              </Styled.Section>
            </Styled.StyledLink>
          </li>
        );
      })}
    </Styled.StyledList>
  );
};
export default ProductsNavSection;
